import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Center,
  Title,
  GridContainer,
  ContainerCard,
  CardImage,
  CardTitle,
  ContentCard,
} from './style';
import { storageServerPath } from "../../../utils/server/api";
import { useServiceShoppingCart } from "../../../hooks/serviceShoppingCart";
import { useAuth } from "@/context/AuthContext";

export default function MySpaceProperty() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { getFinishedOrders, getFinishedPayments, generateCertificate } = useServiceShoppingCart();
  const { user } = useAuth()

  const [orders, setOrders] = useState<any[]>([]);

  useEffect(() => {
    //   getFinishedOrders().then((data) => {
    //     setOrders([...data.data]);
    //   });

        getFinishedPayments().then((data) => {
            console.log(data.data);
            setOrders([...data.data]);
            console.log('====================================');
            console.log(orders);
            console.log('====================================');
        })

    }, []);
    
    console.log(orders);
  if (orders.length == 0) {
      return (
          <Container>
              <Center>
                  <Title>{t("empty-order-warning-1")}</Title>
                  <Title style={{ marginTop: -10 }}>
                      {t("empty-order-warning-2")}
                  </Title>
              </Center>
          </Container>
      );
  }

  return (
      <div className="h-[75vh] w-full p-1 rounded-lg !outline-offset-8 outline-1 outline-gray-300 overflow-y-auto">
        {orders.map((orders, index) => {
            const date = new Date(Date.parse(orders.updated_at));

            return (
                <div className="flex justify-around items-center !border-1 !border-[#50700F] !bg-[#E1E7D6] rounded-lg w-full h-[30%] mb-6 relative" key={index}>
                    <div className="flex items-center justify-center w-[20%] h-full">
                        <img className="w-[90%] !h-[90%] rounded-lg object-cover" src={storageServerPath + orders.file_images?.split(";")[0]} alt="" />
                    </div>

                    <div className="!text-[22px] !text-[#50700F] w-[16%] h-full mt-10">
                        <p>
                            {
                                orders.property_name.length > 50
                                ? (orders.property_name.slice(0, 50) + "...")
                                : orders.property_name
                            }
                        </p>
                    </div>

                    <div className="w-[16%] !text-[18px] h-full mt-10">
                        <p className="!mb-4 !font-bold">{`${t("credits")}:`}</p>
                        <p>{orders.carbon_credits}</p>
                    </div>

                    <div className="w-[16%] !text-[18px] h-full mt-10">
                        <p className="!mb-4 !font-bold">{`${t("payments")}:`}</p>
                        <p>{t(orders.payment_type)}</p>
                    </div>

                    <div className="w-[16%] !text-[18px] h-full mt-10">
                        <p className="!mb-4 !font-bold">{`${t("amount")}:`}</p>
                        <p>{`R$${orders.payment_amount}`}</p>
                    </div>

                    <div className="w-[16%] !text-[18px] h-full mt-10">
                        <p className="!mb-4 !font-bold">{`${t("created_payment")}:`}</p>
                        <p>{date.toLocaleString()}</p>
                    </div>

                    <button onClick={() => generateCertificate(user, orders)} className="absolute bottom-3 right-3 !bg-[#658C39] !px-4 !py-2 rounded-lg !text-white font-medium">
                            Certificado
                    </button>
                </div>
            );
        })}

          {/* <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead style={{ textAlign: "left" }}>
                  <th
                      style={{
                          fontWeight: "bold",
                          borderBottom: "1px solid black",
                      }}
                  >
                      {t("property")}
                  </th>
                  <th
                      style={{
                          fontWeight: "bold",
                          borderBottom: "1px solid black",
                      }}
                  >
                      {t("order-status")}
                  </th>
                  <th
                      style={{
                          fontWeight: "bold",
                          borderBottom: "1px solid black",
                      }}
                  >
                      {t("amount")}
                  </th>
                  <th
                      style={{
                          fontWeight: "bold",
                          borderBottom: "1px solid black",
                      }}
                  >
                      {t("payments")}
                  </th>
                  <th
                      style={{
                          fontWeight: "bold",
                          borderBottom: "1px solid black",
                      }}
                  >
                      {t("created_payment")}
                  </th>
              </thead>
              <tbody>
                  {/* {orders.map((p, index) => (
                      <tr
                          key={index}
                          style={{ borderBottom: "1px solid black" }}
                      >
                          <td>{p.items[0]["property"]?.name}</td>
                          <td>{t(p.status)}</td>
                          <td>{t(p.total)}</td>
                          <td>{t(p.payment_method)}</td>
                          <td>{p.updated_at}</td>
                      </tr>
                  ))} }
                  {orders.map((o, index) => {
                    const date = new Date(Date.parse(o.updated_at))

                    return (<tr
                        key={index}
                        style={{ borderBottom: "1px solid black" }}
                    >
                        <td>{o.property_name}</td>
                        <td>OK</td>
                        <td>{t(o.payment_amount)}</td>
                        <td>{t(o.payment_type)}</td>
                        <td>{date.toLocaleString()}</td>
                    </tr>
                    )})}
              </tbody>
          </table> */}
      </div>
  );
}
